module.exports = __webpack_public_path__ + "img/9788937834851.ed198258.jpg";